import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { useI18n } from "../../context/I18nContext";

export default function ShopNav() {
  const { count } = useCart();
  const { t, lang, setLang } = useI18n();
  return (
    <header className="sticky top-0 z-40 bg-cream/85 backdrop-blur-md border-b border-navy/10">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/shop" data-testid="shop-logo" className="flex items-center">
          <img src="/brand/aura-black.png" alt="AURA · Living Intelligence"
            className="h-7 w-auto object-contain" />
        </Link>
        <div className="flex items-center gap-5">
          <button onClick={() => setLang(lang === "es" ? "en" : "es")} className="text-xs overline text-navy/50 hover:text-navy transition-colors">
            {lang === "es" ? "EN" : "ES"}
          </button>
          <Link to="/shop/track" data-testid="shop-track-link" className="text-sm text-navy/60 hover:text-navy transition-colors hidden sm:inline">{t("shop.trackLink")}</Link>
          <Link to="/login" className="text-sm text-navy/60 hover:text-navy transition-colors hidden sm:inline">{t("shop.enter")}</Link>
          <Link to="/shop/cart" data-testid="shop-cart-link" className="relative inline-flex items-center gap-2 rounded-full border border-navy/15 px-4 py-2 text-sm hover:border-violet hover:text-violet transition-colors">
            <ShoppingBag className="w-4 h-4" /> {t("shop.cart")}
            {count > 0 && <span data-testid="shop-cart-count" className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-gradient-violet text-white text-[10px] flex items-center justify-center">{count}</span>}
          </Link>
        </div>
      </div>
    </header>
  );
}
